import { queryStringHooks } from '../../hooks/queryStringHooks/queryStringHooks';

export const GOOGLE_CLICK_ID = `${CONFIG.basePath}gclid`;

export const hooks = {
  setLocalStorage() {
    const { gclid } = queryStringHooks.useParsedQueryString();

    const googleClickId = gclid?.toString();

    if (googleClickId) {
      localStorage.setItem(GOOGLE_CLICK_ID, googleClickId);
    }
  },
};

export const GoogleClickIdContainer = () => {
  hooks.setLocalStorage();

  return null;
};

GoogleClickIdContainer.displayName = 'GoogleClickIdContainer';
